// @flow
import type {HttpService} from 'modules/common/services/http';
import type {TReportSessionListParams} from 'modules/dashboard/types';
import type {TResponse} from 'types';

/**
 * Сервис для загрузки информации по дашборду админа(не уверен что нужен будет)
 */
export class DashboardApi {
    /**
     * Сервис для отправки HTTP запросов
     */
    _http: HttpService;

    /**
     * @param http Сервис для отправки HTTP запросов
     */
    constructor(http: HttpService) {
        this._http = http;
    }
    /**
     * Получение средних результатов по игровым модулям
     * @return средние результаты по игровым модулям
     */
    async getAverageModuleResult<T>(): TResponse<T> {
        return this._http.get<T>('/game-module/medial', {
            extraOptions: {
                isPrivate: true,
            },
            options: {
                headers: {
                    'Content-Type': 'application/json',
                    'X-http-method-override': 'GET',
                },
            },
        });
    }

    /**
     * Fetch запрос "Получить данные по игровым материалам"
     * @return массив игровых материалов
     */
    async getGameMaterialList<T>(): TResponse<T> {
        return this._http.post<T>('/game-module/game-material-list', {
            extraOptions: {
                isPrivate: true,
            },
        });
    }

    /**
     * Fetch запрос "Запросить ссылку на отчет сессий пользователя"
     * @param data данные для составления отчета
     * @return список игровых модулей
     */
    async reportSessionList<T>(data: TReportSessionListParams): TResponse<T> {
        return this._http.post<T>('/game-module/report-session-list', {
            body: data,
            extraOptions: {
                isPrivate: true,
            },
            options: {
                headers: {
                    'Content-Type': 'application/json',
                    'X-http-method-override': 'POST',
                },
            },
        });
    }
}
